import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import BannerList from './components/BannerList';
import AddBanner from './components/AddBanner';
import UserList from './components/UserList';
import BannerTypes from './components/BannerTypes';
import PrivateRoute from './PrivateRoute';
import AdminRoute from './AdminRoute';
import Stats from './components/Stats';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={() => window.location.href = '/banners'} />} />
        <Route
          path="/banners"
          element={
            <PrivateRoute>
              <BannerList />
            </PrivateRoute>
          }
        />
        <Route
          path="/stats"
          element={
            <PrivateRoute>
              <Stats />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-banner"
          element={
            <PrivateRoute>
              <AddBanner />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-banner/:id"
          element={
            <PrivateRoute>
              <AddBanner />
            </PrivateRoute>
          }
        />
        <Route
          path="/banner-types"
          element={
            <AdminRoute>
              <BannerTypes />
            </AdminRoute>
          }
        />
        <Route
          path="/users"
          element={
            <AdminRoute>
              <UserList />
            </AdminRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
